import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "account_box",
  users: [],
  user: {},
  userRoles: [
    { id: 1, name: "Admin" },
    { id: 2, name: "Consultant" },
    { id: 3, name: "Read-Only" },
    { id: 4, name: "Manager" }
  ]
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
